export var paginationOptions = {
    rowsPerPageText: 'Rows per page',
    rangeSeparatorText: 'of',
};
